import React from 'react';
import { styles } from './TrackList.css';

export type TrackListItem = {
  TrackNumber: number;
  Artist: string;
  Title: string;
};

export type TrackListGroup = {
  TrackGroup: string;
  Tracks: Array<TrackListItem>;
};

export type TrackListProps = {
  trackListGroups?: Array<TrackListGroup>;
};

export const TrackList = ({ trackListGroups }: TrackListProps): JSX.Element => {
  return (
    <>
      {trackListGroups.map((group: TrackListGroup) => (
        <div className={styles.groupItem} key={group.TrackGroup}>
          <h3 className={styles.groupTitle}>{group.TrackGroup}</h3>
          <ol className={styles.groupTrackList}>
            {group.Tracks.map((track: TrackListItem) => (
              <li className={styles.listItem} key={track.Title}>
                {track.Title}
              </li>
            ))}
          </ol>
        </div>
      ))}
    </>
  );
};

export default TrackList;
